module.exports = __webpack_public_path__ + "img/aboutUs.9bed935b.svg";